import { ConditionDTO } from '../../dto';
import { DiscountGroup, ProductGroupType, HierarchyLevels } from '..';

export interface MgSupplierMinimal {
  mgSupplierId: number;
  name: string;
}

export interface ProductGroupMinimal {
  type: ProductGroupType;
  groupNumber: string;
  name: string;
}

interface MgSupplierItemMinimal {
  mgItemNumber: number;
  primaryText: string;
  secondaryText: string;
}

interface ConditionProps {
  id: number;
  validFrom: Date;
  validTo?: Date;
  bindingType?: HierarchyLevels;
  mgSupplier?: MgSupplierMinimal;
  mgSupplierItemId?: number;
  productGroup?: ProductGroupMinimal;
  discountGroup?: DiscountGroup;
  mgSupplierItem?: MgSupplierItemMinimal;
}

export class Condition {
  id: number;
  validFrom?: Date;
  validTo?: Date;
  bindingType?: HierarchyLevels;
  mgSupplier?: MgSupplierMinimal;
  mgSupplierItemId?: number;
  productGroup?: ProductGroupMinimal;
  discountGroup?: DiscountGroup;
  mgSupplierItem?: MgSupplierItemMinimal;

  constructor({
    id,
    validFrom,
    validTo,
    bindingType,
    mgSupplier,
    mgSupplierItemId,
    productGroup,
    discountGroup,
    mgSupplierItem,
  }: ConditionProps) {
    this.id = id;
    this.validFrom = validFrom;
    this.validTo = validTo;
    this.bindingType = bindingType;
    this.mgSupplier = mgSupplier;
    this.mgSupplierItemId = mgSupplierItemId;
    this.productGroup = productGroup;
    this.discountGroup = discountGroup;
    this.mgSupplierItem = mgSupplierItem;
  }

  getLevelName = () => {
    return (
      this.mgSupplierItem?.primaryText ??
      this.productGroup?.name ??
      this.discountGroup?.name ??
      this.mgSupplier?.name
    );
  };

  static fromDto = (dto: ConditionDTO): Condition =>
    new Condition({
      id: dto.id,
      validFrom: new Date(dto.validFrom),
      validTo: dto.validTo ? new Date(dto.validTo) : undefined,
      bindingType: dto.bindingType,
      mgSupplier: dto.mgSupplier,
      mgSupplierItemId: dto.mgSupplierItemId,
      productGroup: dto.productGroup,
      discountGroup: dto.discountGroup,
      mgSupplierItem: dto.mgSupplierItem,
    });
}
